export const FETCH_ALL = 'FETCH_ALL';
export const FETCH_FORM = 'FETCH_FORM';
export const START_LOADING = 'START_LOADING';
export const END_LOADING = 'END_LOADING';
export const ERROR = 'ERROR';
export const CREATE = 'CREATE';
export const UPDATE = 'UPDATE';
export const UPDATE_SUCCESSFUL = 'UPDATE_SUCCESSFUL';
export const DELETE = 'DELETE';
export const DELETE_SUCCESSFUL = 'DELETE_SUCCESSFUL';
export const ADD_ANSWER_SUCCESSFUL = 'ADD_ANSWER_SUCCESSFUL';
export const GET_ANSWERS = 'GET_ANSWERS';

export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const REFRESH_TOKEN_FAIL = 'REFRESH_TOKEN_FAIL';
export const AUTH = 'AUTH';
export const LOGOUT = 'LOGOUT';

// =====================      Auth action types START    =========================

// load logged in user
export const LOAD_USER_REQUEST = 'LOAD_USER_REQUEST'
export const LOAD_USER_SUCCESS = 'LOAD_USER_SUCCESS'
export const LOAD_USER_UPDATE = 'LOAD_USER_UPDATE'
export const LOAD_USER_FAIL = 'LOAD_USER_FAIL'

//get verified user
export const VERIFIED_USER_REQUEST = 'VERIFIED_USER_REQUEST'
export const VERIFIED_USER_SUCCESS = 'VERIFIED_USER_SUCCESS'
export const VERIFIED_USER_FAIL = 'VERIFIED_USER_FAIL'
export const VERIFIED_USER_RESET = 'VERIFIED_USER_RESET'

//get unverified user
export const UNVERIFIED_USER_REQUEST = 'UNVERIFIED_USER_REQUEST'
export const UNVERIFIED_USER_SUCCESS = 'UNVERIFIED_USER_SUCCESS'
export const UNVERIFIED_USER_FAIL = 'UNVERIFIED_USER_FAIL'
export const UNVERIFIED_USER_RESET = 'UNVERIFIED_USER_RESET'

// login 
export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAIL = 'LOGIN_FAIL'
export const AUTH_RESET = 'AUTH_RESET'

// logout 
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const LOGOUT_FAIL = 'LOGOUT_FAIL'
export const LOGOUT_RESET = 'LOGOUT_RESET'

// register employee
export const REGISTER_REQUEST = 'REGISTER_REQUEST'
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'
export const REGISTER_FAIL = 'REGISTER_FAIL'
export const REGISTER_RESET = 'REGISTER_RESET'

// register admin
export const REGISTER_ADMIN_REQUEST = 'REGISTER_ADMIN_REQUEST'
export const REGISTER_ADMIN_SUCCESS = 'REGISTER_ADMIN_SUCCESS'
export const REGISTER_ADMIN_FAIL = 'REGISTER_ADMIN_FAIL'
export const REGISTER_ADMIN_RESET = 'REGISTER_ADMIN_RESET'

// email confirmation
export const VERIFY_EMAIL_REQUEST = 'VERIFY_EMAIL_REQUEST'
export const VERIFY_EMAIL_SUCCESS = 'VERIFY_EMAIL_SUCCESS'
export const VERIFY_EMAIL_FAIL = 'VERIFY_EMAIL_FAIL'
export const VERIFY_EMAIL_RESET = 'VERIFY_EMAIL_RESET'

// load user 
export const GET_USER_REQUEST = 'GET_USER_REQUEST'
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS'
export const GET_USER_FAIL = 'GET_USER_FAIL'

// send verification email 
export const RESEND_VERIFY_EMAIL_REQUEST = 'RESEND_VERIFY_EMAIL_REQUEST'
export const RESEND_VERIFY_EMAIL_SUCCESS = 'RESEND_VERIFY_EMAIL_SUCCESS'
export const RESEND_VERIFY_EMAIL_FAIL = 'RESEND_VERIFY_EMAIL_FAIL'
export const RESEND_VERIFY_EMAIL_RESET = 'RESEND_VERIFY_EMAIL_RESET'

// get user by email
export const GET_USER_BY_EMAIL_REQUEST = 'GET_USER_BY_EMAIL_REQUEST'
export const GET_USER_BY_EMAIL_SUCCESS = 'GET_USER_BY_EMAIL_SUCCESS'
export const GET_USER_BY_EMAIL_FAIL = 'GET_USER_BY_EMAIL_FAIL'
export const GET_USER_BY_EMAIL_RESET = 'GET_USER_BY_EMAIL_RESET'

// get user by email
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_FAIL = 'RESET_PASSWORD_FAIL'
export const RESET_PASSWORD_RESET = 'RESET_PASSWORD_RESET'

// show avatar preview
export const SHOW_AVATAR_PREVIEW_SUCCESS = 'SHOW_AVATAR_PREVIEW_SUCCESS'

// update USER profile
export const UPDATE_PROFILE_REQUEST = 'UPDATE_PROFILE_REQUEST'
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS'
export const UPDATE_PROFILE_FAIL = 'UPDATE_PROFILE_FAIL'
export const UPDATE_PROFILE_RESET = 'UPDATE_PROFILE_RESET'

// update USER profile
export const LOAD_PROFILE_REQUEST = 'LOAD_PROFILE_REQUEST'
export const LOAD_PROFILE_SUCCESS = 'LOAD_PROFILE_SUCCESS'
export const LOAD_PROFILE_FAIL = 'LOAD_PROFILE_FAIL'
export const LOAD_PROFILE_RESET = 'LOAD_PROFILE_RESET'

// update password
export const UPDATE_PASSWORD_REQUEST = 'UPDATE_PASSWORD_REQUEST'
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS'
export const UPDATE_PASSWORD_FAIL = 'UPDATE_PASSWORD_FAIL'
export const UPDATE_PASSWORD_RESET = 'UPDATE_PASSWORD_RESET'


// send emial to USER
export const SEND_EMAIL_TO_EMPLOYEE_REQUEST = 'SEND_EMAIL_TO_EMPLOYEE_REQUEST'
export const SEND_EMAIL_TO_EMPLOYEE_SUCCESS = 'SEND_EMAIL_TO_EMPLOYEE_SUCCESS'
export const SEND_EMAIL_TO_EMPLOYEE_FAIL = 'SEND_EMAIL_TO_EMPLOYEE_FAIL'
export const SEND_EMAIL_TO_EMPLOYEE_RESET = 'SEND_EMAIL_TO_EMPLOYEE_RESET'

// activate or deactivate cv
export const ACTIVATE_OR_DEACTIVATE_REQUEST = 'ACTIVATE_OR_DEACTIVATE_REQUEST'
export const ACTIVATE_OR_DEACTIVATE_SUCCESS = 'ACTIVATE_OR_DEACTIVATE_SUCCESS'
export const ACTIVATE_OR_DEACTIVATE_FAIL = 'ACTIVATE_OR_DEACTIVATE_FAIL'
export const ACTIVATE_OR_DEACTIVATE_RESET = 'ACTIVATE_OR_DEACTIVATE_RESET'

// approve or disapprove cv
export const APPROVE_OR_DISAPPROVE_REQUEST = 'APPROVE_OR_DISAPPROVE_REQUEST'
export const APPROVE_OR_DISAPPROVE_SUCCESS = 'APPROVE_OR_DISAPPROVE_SUCCESS'
export const APPROVE_OR_DISAPPROVE_FAIL = 'APPROVE_OR_DISAPPROVE_FAIL'
export const APPROVE_OR_DISAPPROVE_RESET = 'APPROVE_OR_DISAPPROVE_RESET'



// =====================      Auth action types END    =========================



// =====================   Client action types Start   =========================


// load client
export const LOAD_CLIENT_REQUEST = 'LOAD_CLIENT_REQUEST'
export const LOAD_CLIENT_SUCCESS = 'LOAD_CLIENT_SUCCESS'
export const LOAD_CLIENT_FAIL = 'LOAD_CLIENT_FAIL'
export const LOAD_CLIENT_RESET = 'LOAD_CLIENT_RESET'

// load client
export const GET_CLIENT_REQUEST = 'GET_CLIENT_REQUEST'
export const GET_CLIENT_SUCCESS = 'GET_CLIENT_SUCCESS'
export const GET_CLIENT_FAIL = 'GET_CLIENT_FAIL'
export const CLEAR_GET_CLIENTS = 'CLEAR_GET_CLIENTS'

// Create User
export const CREATE_CLIENT_REQUEST = 'CREATE_CLIENT_REQUEST'
export const CREATE_CLIENT_SUCCESS = 'CREATE_CLIENT_SUCCESS'
export const CREATE_CLIENT_FAIL = 'CREATE_CLIENT_FAIL'
export const CLEAR_CLIENT = 'CLEAR_CLIENT'

// delete client
export const DELETE_CLIENT_REQUEST = 'DELETE_CLIENT_REQUEST'
export const DELETE_CLIENT_SUCCESS = 'DELETE_CLIENT_SUCCESS'
export const DELETE_CLIENT_FAIL = 'DELETE_CLIENT_FAIL'
export const DELETE_CLIENT_RESET = 'DELETE_CLIENT_RESET'


// update client
export const UPDATE_CLIENT_REQUEST = 'UPDATE_CLIENT_REQUEST'
export const UPDATE_CLIENT_SUCCESS = 'UPDATE_CLIENT_SUCCESS'
export const UPDATE_CLIENT_FAIL = 'UPDATE_CLIENT_FAIL'
export const UPDATE_CLIENT_RESET = 'UPDATE_CLIENT_RESET'


// =====================  Ends Client action types Start   =========================

// =====================  Start Client action types Start   =========================

// load roles
export const GET_ROLE_SUCCESS = 'GET_ROLE_SUCCESS'
export const GET_ROLE_FAIL = 'GET_ROLE_FAIL'
export const GET_ROLE_REQUEST = 'GET_ROLE_REQUEST'


// =====================  Start Subadmin action types Start   =========================

// load client
export const LOAD_SUBADMIN_REQUEST = 'LOAD_SUBADMIN_REQUEST'
export const LOAD_SUBADMIN_SUCCESS = 'LOAD_SUBADMIN_SUCCESS'
export const LOAD_SUBADMIN_FAIL = 'LOAD_SUBADMIN_FAIL'
export const LOAD_SUBADMIN_RESET = 'LOAD_SUBADMIN_RESET'

// load SUBADMIN
export const GET_SUBADMIN_REQUEST = 'GET_SUBADMIN_REQUEST'
export const GET_SUBADMIN_SUCCESS = 'GET_SUBADMIN_SUCCESS'
export const GET_SUBADMIN_FAIL = 'GET_SUBADMIN_FAIL'
export const CLEAR_GET_SUBADMINS = 'CLEAR_GET_SUBADMINS'

// load DASHBOARD
export const GET_ADMIN_DASHBOARD_REQUEST = 'GET_ADMIN_DASHBOARD_REQUEST'
export const GET_ADMIN_DASHBOARD_SUCCESS = 'GET_ADMIN_DASHBOARD_SUCCESS'
export const GET_ADMIN_DASHBOARD_FAIL = 'GET_ADMIN_DASHBOARD_FAIL'
export const CLEAR_GET_ADMIN_DASHBOARD = 'CLEAR_GET_ADMIN_DASHBOARD'

// load ADMIN DASHBOARD PROJECT
export const GET_ADMIN_DASHBOARD_PROJECT_REQUEST = 'GET_ADMIN_DASHBOARD_PROJECT_REQUEST'
export const GET_ADMIN_DASHBOARD_PROJECT_SUCCESS = 'GET_ADMIN_DASHBOARD_PROJECT_SUCCESS'
export const GET_ADMIN_DASHBOARD_PROJECT_FAIL = 'GET_ADMIN_DASHBOARD_PROJECT_FAIL'
export const CLEAR_GET_ADMIN_DASHBOARD_PROJECT = 'CLEAR_GET_ADMIN_DASHBOARD_PROJECT'

// create SUBADMIN
export const CREATE_SUBADMIN_REQUEST = 'CREATE_SUBADMIN_REQUEST'
export const CREATE_SUBADMIN_SUCCESS = 'CREATE_SUBADMIN_SUCCESS'
export const CREATE_SUBADMIN_FAIL = 'CREATE_SUBADMIN_FAIL'
export const CLEAR_SUBADMIN = 'CLEAR_SUBADMIN'

// delete SUBADMIN
export const DELETE_SUBADMIN_REQUEST = 'DELETE_SUBADMIN_REQUEST'
export const DELETE_SUBADMIN_SUCCESS = 'DELETE_SUBADMIN_SUCCESS'
export const DELETE_SUBADMIN_FAIL = 'DELETE_SUBADMIN_FAIL'
export const DELETE_SUBADMIN_RESET = 'DELETE_SUBADMIN_RESET'


// update SUBADMIN
export const UPDATE_SUBADMIN_REQUEST = 'UPDATE_SUBADMIN_REQUEST'
export const UPDATE_SUBADMIN_SUCCESS = 'UPDATE_SUBADMIN_SUCCESS'
export const UPDATE_SUBADMIN_FAIL = 'UPDATE_SUBADMIN_FAIL'
export const UPDATE_SUBADMIN_RESET = 'UPDATE_SUBADMIN_RESET'

// =====================  End Subadmin action types Start   =========================
// =====================  Start Subscription action types Start   =====================

export const LOAD_SUBSCRIPTION_REQUEST = 'LOAD_SUBSCRIPTION_REQUEST'
export const LOAD_SUBSCRIPTION_SUCCESS = 'LOAD_SUBSCRIPTION_SUCCESS'
export const LOAD_SUBSCRIPTION_FAIL = 'LOAD_SUBSCRIPTION_FAIL'
export const LOAD_SUBSCRIPTION_RESET = 'LOAD_SUBSCRIPTION_RESET'

// load SUBSCRIPTION
export const GET_SUBSCRIPTION_REQUEST = 'GET_SUBSCRIPTION_REQUEST'
export const GET_SUBSCRIPTION_SUCCESS = 'GET_SUBSCRIPTION_SUCCESS'
export const GET_SUBSCRIPTION_FAIL = 'GET_SUBSCRIPTION_FAIL'
export const CLEAR_GET_SUBSCRIPTIONS = 'CLEAR_GET_SUBSCRIPTIONS'

// create SUBSCRIPTION
export const CREATE_SUBSCRIPTION_REQUEST = 'CREATE_SUBSCRIPTION_REQUEST'
export const CREATE_SUBSCRIPTION_SUCCESS = 'CREATE_SUBSCRIPTION_SUCCESS'
export const CREATE_SUBSCRIPTION_FAIL = 'CREATE_SUBSCRIPTION_FAIL'
export const CLEAR_SUBSCRIPTION = 'CLEAR_SUBSCRIPTION'

// delete SUBSCRIPTION
export const DELETE_SUBSCRIPTION_REQUEST = 'DELETE_SUBSCRIPTION_REQUEST'
export const DELETE_SUBSCRIPTION_SUCCESS = 'DELETE_SUBSCRIPTION_SUCCESS'
export const DELETE_SUBSCRIPTION_FAIL = 'DELETE_SUBSCRIPTION_FAIL'
export const DELETE_SUBSCRIPTION_RESET = 'DELETE_SUBSCRIPTION_RESET'


// update SUBSCRIPTION
export const UPDATE_SUBSCRIPTION_REQUEST = 'UPDATE_SUBSCRIPTION_REQUEST'
export const UPDATE_SUBSCRIPTION_SUCCESS = 'UPDATE_SUBSCRIPTION_SUCCESS'
export const UPDATE_SUBSCRIPTION_FAIL = 'UPDATE_SUBSCRIPTION_FAIL'
export const UPDATE_SUBSCRIPTION_RESET = 'UPDATE_SUBSCRIPTION_RESET'

// =====================  End Subscription action types Start   =====================

// load EMAIL TEMPLATES
export const GET_EMAIL_TEMPLATE_REQUEST = 'GET_EMAIL_TEMPLATES_REQUEST'
export const GET_EMAIL_TEMPLATE_SUCCESS = 'GET_EMAIL_TEMPLATES_SUCCESS'
export const GET_EMAIL_TEMPLATE_FAIL = 'GET_EMAIL_TEMPLATES_FAIL'
export const CLEAR_GET_EMAIL_TEMPLATE = 'CLEAR_GET_EMAIL_TEMPLATESS'


// create EMAIL TEMPLATES
export const CREATE_EMAIL_TEMPLATE_REQUEST = 'CREATE_EMAIL_TEMPLATE_REQUEST'
export const CREATE_EMAIL_TEMPLATE_SUCCESS = 'CREATE_EMAIL_TEMPLATE_SUCCESS'
export const CREATE_EMAIL_TEMPLATE_FAIL = 'CREATE_EMAIL_TEMPLATE_FAIL'
export const CLEAR_CREATE_EMAIL_TEMPLATE = 'CLEAR_CREATE_EMAIL_TEMPLATE'

// LOAD EMAIL TEMPLATES
export const LOAD_EMAIL_TEMPLATE_REQUEST = 'LOAD_EMAIL_TEMPLATE_REQUEST'
export const LOAD_EMAIL_TEMPLATE_SUCCESS = 'LOAD_EMAIL_TEMPLATE_SUCCESS'
export const LOAD_EMAIL_TEMPLATE_FAIL = 'LOAD_EMAIL_TEMPLATE_FAIL'
export const LOAD_EMAIL_TEMPLATE_RESET = 'LOAD_EMAIL_TEMPLATE_RESET'

// =====================  Start Payment History action types Start   =====================

// load payment history
export const GET_PAYMENT_HISTORY_REQUEST = 'GET_PAYMENT_HISTORY_REQUEST'
export const GET_PAYMENT_HISTORY_SUCCESS = 'GET_PAYMENT_HISTORY_SUCCESS'
export const GET_PAYMENT_HISTORY_FAIL = 'GET_PAYMENT_HISTORY_FAIL'
export const CLEAR_GET_PAYMENT_HISTORY = 'CLEAR_GET_PAYMENT_HISTORY'


// update EMAIL TEMPLATE
export const UPDATE_EMAIL_TEMPLATE_REQUEST = 'UPDATE_EMAIL_TEMPLATE_REQUEST'
export const UPDATE_EMAIL_TEMPLATE_SUCCESS = 'UPDATE_EMAIL_TEMPLATE_SUCCESS'
export const UPDATE_EMAIL_TEMPLATE_FAIL = 'UPDATE_EMAIL_TEMPLATE_FAIL'
export const UPDATE_EMAIL_TEMPLATE_RESET = 'UPDATE_EMAIL_TEMPLATE_RESET'

// delete SUBSCRIPTION
export const DELETE_EMAIL_TEMPLATE_REQUEST = 'DELETE_EMAIL_TEMPLATE_REQUEST'
export const DELETE_EMAIL_TEMPLATE_SUCCESS = 'DELETE_EMAIL_TEMPLATE_SUCCESS'
export const DELETE_EMAIL_TEMPLATE_FAIL = 'DELETE_EMAIL_TEMPLATE_FAIL'
export const DELETE_EMAIL_TEMPLATE_RESET = 'DELETE_EMAIL_TEMPLATE_RESET'


// get  OBJECTIVE AND AUDIENCE 
export const GET_OBJECTIVE_REQUEST = 'GET_OBJECTIVE_REQUEST'
export const GET_OBJECTIVE_SUCCESS = 'GET_OBJECTIVE_SUCCESS'
export const GET_OBJECTIVE_FAIL = 'GET_OBJECTIVE_FAIL'
export const CLEAR_GET_OBJECTIVE = 'CLEAR_GET_OBJECTIVE'


// create  OBJECTIVE AND AUDIENCE 
export const CREATE_OBJECTIVE_REQUEST = 'CREATE_OBJECTIVE_REQUEST'
export const CREATE_OBJECTIVE_SUCCESS = 'CREATE_OBJECTIVE_SUCCESS'
export const CREATE_OBJECTIVE_FAIL = 'CREATE_OBJECTIVE_FAIL'
export const CLEAR_CREATE_OBJECTIVE = 'CLEAR_CREATE_OBJECTIVE'


// update OBJECTIVE AND AUDIENCE 
export const UPDATE_OBJECTIVE_REQUEST = 'UPDATE_OBJECTIVE_REQUEST'
export const UPDATE_OBJECTIVE_SUCCESS = 'UPDATE_OBJECTIVE_SUCCESS'
export const UPDATE_OBJECTIVE_FAIL = 'UPDATE_OBJECTIVE_FAIL'
export const UPDATE_OBJECTIVE_RESET = 'UPDATE_OBJECTIVE_RESET'

// delete  OBJECTIVE AND AUDIENCE 
export const DELETE_OBJECTIVE_REQUEST = 'DELETE_OBJECTIVE_REQUEST'
export const DELETE_OBJECTIVE_SUCCESS = 'DELETE_OBJECTIVE_SUCCESS'
export const DELETE_OBJECTIVE_FAIL = 'DELETE_OBJECTIVE_FAIL'
export const DELETE_OBJECTIVE_RESET = 'DELETE_OBJECTIVE_RESET'

// audience 

// get AUDIENCE 
export const GET_AUDIENCE_REQUEST = 'GET_AUDIENCE_REQUEST'
export const GET_AUDIENCE_SUCCESS = 'GET_AUDIENCE_SUCCESS'
export const GET_AUDIENCE_FAIL = 'GET_AUDIENCE_FAIL'
export const CLEAR_GET_AUDIENCE = 'CLEAR_GET_AUDIENCE'
// create AUDIENCE 
export const CREATE_AUDIENCE_REQUEST = 'CREATE_AUDIENCE_REQUEST'
export const CREATE_AUDIENCE_SUCCESS = 'CREATE_AUDIENCE_SUCCESS'
export const CREATE_AUDIENCE_FAIL = 'CREATE_AUDIENCE_FAIL'
export const CLEAR_CREATE_AUDIENCE = 'CLEAR_CREATE_AUDIENCE'
// update AUDIENCE 
export const UPDATE_AUDIENCE_REQUEST = 'UPDATE_AUDIENCE_REQUEST'
export const UPDATE_AUDIENCE_SUCCESS = 'UPDATE_AUDIENCE_SUCCESS'
export const UPDATE_AUDIENCE_FAIL = 'UPDATE_AUDIENCE_FAIL'
export const UPDATE_AUDIENCE_RESET = 'UPDATE_AUDIENCE_RESET'
// delete AUDIENCE 
export const DELETE_AUDIENCE_REQUEST = 'DELETE_AUDIENCE_REQUEST'
export const DELETE_AUDIENCE_SUCCESS = 'DELETE_AUDIENCE_SUCCESS'
export const DELETE_AUDIENCE_FAIL = 'DELETE_AUDIENCE_FAIL'
export const DELETE_AUDIENCE_RESET = 'DELETE_AUDIENCE_RESET'

// create HOME PAGE
export const CREATE_HOME_PAGE_REQUEST = 'CREATE_HOME_PAGE_REQUEST'
export const CREATE_HOME_PAGE_SUCCESS = 'CREATE_HOME_PAGE_SUCCESS'
export const CREATE_HOME_PAGE_FAIL = 'CREATE_HOME_PAGE_FAIL'
export const CLEAR_CREATE_HOME_PAGE = 'CLEAR_CREATE_HOME_PAGE'

// get  OBJECTIVE AND AUDIENCE 
export const GET_HOME_PAGE_REQUEST = 'GET_HOME_PAGE_REQUEST'
export const GET_HOME_PAGE_SUCCESS = 'GET_HOME_PAGE_SUCCESS'
export const GET_HOME_PAGE_FAIL = 'GET_HOME_PAGE_FAIL'
